import { NumericalChangeActionsE } from '../constants'
import { ActionsList } from '../util/contstants'

export interface NumericalChangeEvent {
    action: NumericalChangeActionsE
    value: number | string
    source?: 'value' | 'variable'
}

export interface ActionParamsSetState {
    type: typeof ActionsList.SetState
    extra: number
}

export interface NumericalChangeExtra {
    action: NumericalChangeActionsE
    value: number | string
    source?: 'value' | 'variable'
}

export interface ActionParamsSetDailyBudget {
    type: typeof ActionsList.SetDailyBudget
    extra: NumericalChangeExtra
}

export interface ActionParamsSetDefaultBid {
    type: typeof ActionsList.SetDefaultBid
    extra: NumericalChangeExtra
}

export interface ActionParamsSetBid {
    type: typeof ActionsList.SetBid
    extra: NumericalChangeExtra
}

export interface ActionParamsCreateExactMatchNegative {
    type: typeof ActionsList.CreateExactMatchNegative
}

export interface ActionParamsChangeBiddingStrategy {
    type: typeof ActionsList.ChangeBiddingStrategy
    extra: 'SALES_DOWN_ONLY' | 'SALES' | 'NONE'
}

export interface ActionParamsChangeBidAdjustment {
    type: typeof ActionsList.ChangeBidAdjustment
    extra: Partial<Record<'tos_placement' | 'ros_placement' | 'pp_placement', number>>
}

export type ActionParams =
    | ActionParamsSetState
    | ActionParamsSetDailyBudget
    | ActionParamsSetDefaultBid
    | ActionParamsSetBid
    | ActionParamsCreateExactMatchNegative
    | ActionParamsChangeBiddingStrategy
    | ActionParamsChangeBidAdjustment

export type ActionParamsWithExtra =
    | ActionParamsSetState
    | ActionParamsSetDailyBudget
    | ActionParamsSetDefaultBid
    | ActionParamsSetBid

export const hasExtraProperty = (params: ActionParams): params is ActionParamsWithExtra => {
    return 'extra' in (params as any) && (params as any).extra !== undefined
}

/**
 * MER-2802: Amazon entity ids arrive as either a JSON number or a JSON string,
 * depending on which backend served the row. Never narrow one to the other —
 * `Number()` truncates ids above 2^53-1. Compare with `String(...)` on both sides.
 */
export type EntityId = number | string

/** The canonical comparison/lookup key for an Amazon entity id. */
export const idKey = (value: unknown): string => String(value)

export interface SelectionI {
    all: boolean
    safeList: EntityId[]
    blockList: EntityId[]
    selectedCount: number
}

export interface SelectionSet {
    all: boolean
    safeList: Set<EntityId>
    blockList: Set<EntityId>
    selectedCount: number
}
